import { Checkbox } from '@jisr-hr/ds'
import { Card } from 'components/global/atoms'

export type TRadioWithContentOption = {
  label: string
  value: string
  testId?: string
}

type TRadioWithContent = {
  options: TRadioWithContentOption[]
  value: string[] | undefined
  handleChange: (val: string[]) => void
}

export function MultiChoiceAnswers({ options = [], value, handleChange }: TRadioWithContent) {
  const onChange = (v: string) => {
    if (Array.isArray(value)) {
      const selected = value?.includes(v)
      if (selected) {
        handleChange(value.filter((item) => item !== v))
      } else {
        handleChange([...value, v])
      }
    } else if (!value) {
      handleChange([v])
    }
  }

  return (
    <>
      <div className="w-[80%]">
        {options.map((opt, index) => {
          const selected = value?.includes(opt?.value)
          return (
            <div
              key={index}
              onClick={() => onChange(opt.value)}
            >
              <Card className="cursor-pointer my-4">
                <Checkbox
                  active={selected}
                  onChange={() => onChange(opt.value)}
                  label={opt.label}
                />
              </Card>
            </div>
          )
        })}
      </div>
    </>
  )
}
